import { getDigiwiseAccountBaseUrl } from '@/shared/api/digiwise-client';
import { ROUTES } from '@/routes/constants';
import type { GetCurrentUserOutputDTO } from '@/shared/types/api/getCurrentUserOutputDTO';
import { TermsAcceptanceStatusType } from '@/shared/types/api/termsAcceptanceStatusType';

export function userRequiresIdentityVerification(user: GetCurrentUserOutputDTO): boolean {
  // Terms gate owns the pre-terms state; identity gate only applies after acceptance.
  return (
    user.terms_acceptance_status === TermsAcceptanceStatusType.ACCEPTED && !user.identity_verified
  );
}

export function startIdentityVerification(): void {
  const redirectUri = encodeURIComponent(`${window.location.origin}${ROUTES.PROFILE.path}`);
  window.location.href = `${getDigiwiseAccountBaseUrl()}/individual-registration?redirect_uri=${redirectUri}`;
}
